// Keep in sync with migrations/1791225577-add-site-footer-to-template.js.
export type FooterVariant = 'default' | 'minimal';

export const resolveFooterVariant = (
  fields?: { siteFooter?: unknown } | null,
): FooterVariant => {
  return fields?.siteFooter === 'Minimal' ? 'minimal' : 'default';
};
